import type { AssetSource, FileAssetSource, UrlAssetSource } from "../assetTypes.ts";

export const isUrl = (source: AssetSource): source is UrlAssetSource => "url" in source;

export const isFile = (source: AssetSource): source is FileAssetSource => "assetId" in source;
